import React from 'react';
import {HealthSpecialtySelectionProps} from './types';
import {useHealthSpecialtyList} from './hooks/useHealthSpecialtyList';
import {BookingLoadingState} from 'presentation/modules/booking/shared/ui/components/BookingLoadingState';
import {translations} from 'presentation/translations-new';
import {BookingErrorState} from 'presentation/modules/booking/shared/ui/components/BookingErrorState';
import {BookingEmptyState} from 'presentation/modules/booking/shared/ui/components/BookingEmptyState';
import {BookingSearchEmptyState} from 'presentation/modules/booking/shared/ui/components/BookingSearchEmptyState';
import {FlowEnum} from 'presentation/modules/booking/shared/constants/flowEnum';
import {FinishWithoutCompleteFlowEnum} from 'main/analytics/gaTagsEnum';
import {HealthSpecialtyNotFound} from './components/HealthSpecialtyNotFound';
import {HealthSpecialtiesList} from './components/HealthSpecialtiesList';

const {bookHealth} = translations['pt-br'].privateFlow.services;
const {loadingError, loadingState} = translations['pt-br'].privateFlow.bookingFlow.specialtyFlow;
const {emptyDescription} = translations['pt-br'].commons;

export function HealthSpecialtySelection({handleNextStep}: HealthSpecialtySelectionProps) {
	const {
		isFetching,
		specialtiesListHasUnprocessableError,
		specialtiesListError,
		refetchSpecialtiesList,
		showEmptyState,
		showNotFoundState,
		handleNavToStateSelection,
		specialtiesList,
		mostSearchedSpecialties,
	} = useHealthSpecialtyList();

	if (isFetching) {
		return (
			<BookingLoadingState
				showHeader={false}
				pageTitle={bookHealth}
				loadingText={loadingState}
			/>
		);
	}

	if (specialtiesListError && !specialtiesListHasUnprocessableError) {
		return (
			<BookingErrorState
				showHeader={false}
				pageTitle={bookHealth}
				errorTitle={loadingError}
				handleRefresh={refetchSpecialtiesList}
			/>
		);
	}

	if (showNotFoundState) {
		return <HealthSpecialtyNotFound handleAction={handleNavToStateSelection} />;
	}

	if (showEmptyState) {
		return (
			<BookingSearchEmptyState
				flowType={FlowEnum.HEALTH}
				dataTagId={FinishWithoutCompleteFlowEnum.SEM_ESPECIALIDADE_ENCONTRADA}>
				<BookingEmptyState
					description={emptyDescription}
					flowType={FlowEnum.HEALTH}
					dataTagId={FinishWithoutCompleteFlowEnum.SEM_ESPECIALIDADE_ENCONTRADA}
				/>
			</BookingSearchEmptyState>
		);
	}
	return (
		<HealthSpecialtiesList
			handleNextStep={handleNextStep}
			specialtiesList={specialtiesList!}
			mostSearchedSpecialties={mostSearchedSpecialties}
		/>
	);
}
